import { ApiNumber } from 'types/models/ApiNumber';
import AdvantagesSection from '@components/molecules/AdvantagesSection';
import SuitcaseIcon from 'assets/icons/suitcase.svg';
import ExpertKnowledgeIcon from 'assets/icons/expert-knowledge.svg';
import ScaleIcon from 'assets/icons/scale.svg';
import TickInCircle from 'assets/icons/tick-in-circle.svg';
import CoffeIcon from 'assets/icons/coffee.svg';
import ShieldIcon from 'assets/icons/shield.svg';
import StonksIcon from 'assets/icons/stonks.svg';
import LikeIcon from 'assets/icons/like.svg';
import SVGComponent from 'types/SVGComponent';
import { FormattedMessage, MessageDescriptor, MessageVariables } from 'utils/intl';
import { getNumber } from 'utils/getNumber';
import getListWithId from 'utils/getListWithId';

import messages from './WhyTrustUs.messages';

type Props = {
  numbers?: ApiNumber[];
};

type Item = {
  id: number;
  header: MessageDescriptor & { values?: MessageVariables };
  description: MessageDescriptor & { values?: MessageVariables };
  icon: SVGComponent;
};

const getItems = (numbers: ApiNumber[]): Item[] =>
  getListWithId([
    {
      header: messages.suitcaseHeader,
      description: messages.suitcaseDescription,
      icon: SuitcaseIcon,
    },
    {
      header: messages.expertHeader,
      description: messages.expertDescription,
      icon: ExpertKnowledgeIcon,
    },
    {
      header: messages.scaleHeader,
      description: messages.scaleDescription,
      icon: ScaleIcon,
    },
    {
      header: messages.originalHeader,
      description: messages.originalDescription,
      icon: TickInCircle,
    },
    {
      header: messages.coffeeHeader,
      description: messages.coffeDescription,
      icon: CoffeIcon,
    },
    {
      header: messages.shieldHeader,
      description: messages.shieldDescription,
      icon: ShieldIcon,
    },
    {
      header: { ...messages.stonksHeader, values: { clients: getNumber(numbers, 'CLIENTS') } },
      description: { ...messages.stonksDescription, values: { allDeliveries: getNumber(numbers, 'ALL_DELIVERIES') } },
      icon: StonksIcon,
    },
    {
      header: messages.likeHeader,
      description: messages.likeDescription,
      icon: LikeIcon,
    },
  ]);

const WhyTrustUs = ({ numbers = [] }: Props): JSX.Element => (
  <AdvantagesSection title={<FormattedMessage {...messages.title} />} itemsPerRow={4}>
    {getItems(numbers).map(({ id, header, description, icon }) => (
      <AdvantagesSection.Item
        key={id}
        header={<FormattedMessage {...header} />}
        description={<FormattedMessage {...description} />}
        icon={icon}
      />
    ))}
  </AdvantagesSection>
);

export default WhyTrustUs;
